import { zonedDate } from '../../../../utils/date-time';
import { useMemo } from 'react';
import moment from 'moment';
import { Modal } from '../../../../components/Modal';
import { AgendaForm } from '../../../agenda/estabelecimento/Form/Form';

interface AssignModalProps {
    entry: any;
    onClose: () => void;
    onAssigned: () => void;
}

const buildDocFromEntry = (entry: any) => {
    const preferredStartAt = entry?.preferredStartAt ? new Date(entry.preferredStartAt) : new Date();
    const attendantId = entry?.attendant?.uid || entry?.attendantId || '';
    return {
        servico_id: entry?.servico?._id || entry?.servicoId,
        servicos_extras_ids: entry?.servicosExtrasIds || [],
        atendente_id: attendantId,
        clientId: entry?.client?.uid || entry?.clientId,
        duration: entry?.totalDuration,
        startAt: preferredStartAt,
        waitlistEntryId: entry?._id,
    };
};

export default function AssignModal({ entry, onClose, onAssigned }: AssignModalProps) {
    const doc = useMemo(() => buildDocFromEntry(entry), [entry]);
    const lockAtendente = Boolean(doc?.atendente_id);
    const start = entry?.preferredStartAt ? zonedDate(entry.preferredStartAt, entry.timezone).format('DD/MM/YYYY') : '';
    const end = entry?.preferredEndAt ? zonedDate(entry.preferredEndAt, entry.timezone).format('DD/MM/YYYY') : '';
    const subTitle = [entry?.client?.name, start && end && start !== end ? `${start} a ${end}` : start]
        .filter(Boolean)
        .join(' · ');

    return (
        <Modal title="Agendar da fila" subTitle={subTitle} onClose={onClose}>
            <AgendaForm
                doc={doc}
                onDone={() => {
                    onAssigned();
                }}
                redirectOnCreate={false}
                embedded
                lockServico
                lockCliente
                lockAtendente={lockAtendente}
                waitlistEntryId={entry?._id}
            />
        </Modal>
    );
}
